import { defineMessages } from 'react-intl';

export const loyaltyMessages = defineMessages({
  pointsToEarnText: {
    id: 'pd.loyalty.banner.pointsToEarnText',
    defaultMessage: 'You will earn <b>{points} points</b> from this purchase!',
  },
  loginText: {
    id: 'pd.loyalty.banner.loginText',
    defaultMessage:
      'Nakupte, získejte body a vyměňte je za odměny ve věrnostním programu! Nejprve se ale přihlašte.',
  },
  login: {
    id: 'pd.loyalty.banner.login',
    defaultMessage: 'Přihlásit',
  },
  joinNotinoClubCta: {
    id: 'pd.loyalty.banner.joinNotinoClubCta',
    defaultMessage:
      'Přidejte se do Notino Club a začněte sbírat body a odměny.',
  },
  findOutMore: {
    id: 'pd.loyalty.banner.findOutMore',
    defaultMessage: 'Zjistit více',
  },
  drawerAndModalTitle: {
    id: 'pd.loyalty.banner.drawerAndModalTitle',
    defaultMessage:
      'Sbírejte body za každý nákup a užívejte si exkluzivní odměny a slevy',
  },
  pointsPerPurchase: {
    id: 'pd.loyalty.banner.pointsPerPurchase',
    defaultMessage: 'Body za každý nákup',
  },
  pointsPerPurchaseDescription: {
    id: 'pd.loyalty.banner.pointsPerPurchaseDescription',
    defaultMessage: '1 Kč = 1 bod',
  },
  extraPointsForActivity: {
    id: 'pd.loyalty.banner.extraPointsForActivity',
    defaultMessage: 'Extra body za aktivitu',
  },
  extraPointsForActivityDescription: {
    id: 'pd.loyalty.banner.extraPointsForActivityDescription',
    defaultMessage: 'Třeba za napsání recenze. Body navíc se vždy hodí!',
  },
  rewardsForPoints: {
    id: 'pd.loyalty.banner.rewardsForPoints',
    defaultMessage: 'Odměny za body',
  },
  rewardsForPointsDescription: {
    id: 'pd.loyalty.banner.rewardsForPointsDescription',
    defaultMessage:
      'Máme pro vás krásné beauty dárky! Získejte je za nasbírané body.',
  },
  specialDiscounts: {
    id: 'pd.loyalty.banner.specialDiscounts',
    defaultMessage: 'Speciální slevy jen pro členy',
  },
  specialDiscountsDescription: {
    id: 'pd.loyalty.banner.specialDiscountsDescription',
    defaultMessage:
      'Body si můžete vyměnit i za výhodné slevy na spoustu produktů.',
  },

  join: {
    id: 'pd.loyalty.banner.join',
    defaultMessage: 'Vstoupit',
  },
  subscribeNewsletter: {
    id: 'pd.loyalty.banner.subscribeNewsletter',
    defaultMessage: 'Odebírat newsletter',
  },
  policy: {
    id: 'pd.loyalty.banner.policy',
    defaultMessage:
      'Pokračováním potvrzujete, že jste si přečetli a souhlasíte s <loyalProgramLink>podmínkami věrnostního programu</loyalProgramLink> a <privacyPolicyLink>zásadami ochrany osobních údajů</privacyPolicyLink>.',
  },
  loyalProgramLink: {
    id: 'pd.loyalty.banner.loyalProgramLink',
    defaultMessage:
      'https://www.notino.cz/obchodni-podminky-vedeni-zakaznickeho-uctu-notino-a-clenstvi-v-notino-clubu/',
  },
  privacyPolicyLink: {
    id: 'pd.loyalty.banner.privacyPolicyLink',
    defaultMessage: 'https://www.notino.cz/ochrana-osobnich-udaju/',
  },
  errorMessage: {
    id: 'pd.loyalty.banner.errorMessage',
    defaultMessage: 'Ajjaj něco se pokazilo, zkus to ještě jednou',
  },
  successMessage: {
    id: 'pd.loyalty.banner.successMessage',
    defaultMessage:
      'Vítejte v Notino Club! Nakupujte, sbírejte body a proměňte je na odměny a výhody!',
  },
  notinoClub: {
    id: 'pd.loyalty.toaster.notino.club',
    defaultMessage: 'Notino Club',
  },
});
